import { services } from "./data";


export const prf = {
  sp: "solopreneur",
  st: "startup",
  sm: "SME",
  md: "Medium Enterprise",
  lg: "Large Enterprise",
}

export const projects = [

  { client: "amossa interior",
    starred: true,
    services: [1, 2],
    metadata: {
      descr: "Interior design studio",
      overview: "Dans le but de renforcer sa position en tant que studio de design d’intérieur innovant, Amossa Interior nous a sollicités pour créer son identité de marque. Nous avons mené des recherches et conceptualisé une identité unique qui incarne l’esprit d’Amossa : donner vie aux espaces.",
      thumbnail: "_cover.jpg",
      seemore: "https://www.instagram.com/p/CQZUWgQLDPZ/?img_index=1",
      credits: [
        { title: "Identité de marque", by: "us" },
        { title: "Co-Direction Artistique", by: "Ramatoulaye Camara (Amossa Interior)" }
      ],
      link: "",
      industry: ["interior design"],
      year: 2022,
      profile: prf.sm,
    },
  },
    { client: "annagram",
    services: [1,4],
    metadata: {
      descr: "software engineering, IOT — internet of things",
      overview: "Annagram Tech Labs is a software engineering firm based in Dakar, providing a variety of services ranking from app / web design & development",
      thumbnail: "_cover.jpg",
      seemore: "https://www.instagram.com/annagram",
      /* credits: [
        { title: "Identity design", by: "Daouda Diallo (LAWWD)" },
      ], */
      link: "",
      industry: ["tech"],
      year: 2025,
      profile: prf.st,
    },
  },
  { client: "anima iris",
    services: [2],
    metadata: {
      descr: "Luxury handbags",
      overview: "For its installment in Senegal, we creative directed and produced the Anima Iris campaign, breaking the bridge between cultures",
      thumbnail: "_cover.jpg",
      seemore: "https://www.instagram.com/p/CQZUWgQLDPZ/?img_index=1",
      credits: [
        { title: "Co-Direction Artistique", by: "Marilyn Quarshie (Anima Iris)" },
        { title: "Project Manager", by: "Sarah Nina Diallo" },
        { title: "Photography & Editing", by: "Daouda Diallo (LAWWD)" },
        { title: "Photography Assistant", by: "Seydou N. Ly" },
      ],
      link: "",
      industry: ["fashion"],
      year: 2020,
      profile: prf.sm,
    },
  },
  { client: "appwrite",
    services: [4],
    metadata: {
      descr: "SAAS for backend provider",
      overview: "Nous avons conçu l'interface riche du fournisseur de Backend Appwrite. Une démonstration des fonctionalités innovantes que cette empreinte dans le monde de la gestion des données numériques offre.",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["tech"],
      year: 2024,
      profile: prf.md,
    },
  },
  { client: "barbu",
    services: [3],
    metadata: {
      descr: "Motion 3D lancement Kit pour Barbe",
      overview: <>Après un travail acharné sur la production de son kit pour barbe, notre cliente nous a laissé le soin de créer sa campagne de lancement. <br /><br /> Nous avons réalisé une production complète en 3D prenant en charge la quasi-totalité de ses besoins en création de contenu pour objectifs de communication.</>,
      delivrables: [
        {section : "Rendus 3D", items:[
          {item:"Photos produits (3D)"},
          {item:"Carte présentation de produit (3D)"},
        ]},
        {section : "Supports de com.", items:[
          {item:"Flyer composantes box"},
          {item:"Kakemono 1M x 2M"},
        ]}
      ],
      link: "",
      thumbnail: "_cover.png",
      industry: ["beauty"],
      year: 2022,
      profile: prf.sm,
    },
  },
/*   { client: "bin",
    caseStudy: true,
    services: [5],
    metadata: {
      descr: "R&D conception produit",
      link: "",
      thumbnail: "_cover.png",
      tags: ["product design", "bottle", "blender"],
      css: "object-bottom",
      industry: ["consumer goods", "utilities"],
      year: 2018,
      profile: prf.sm,
    },
  }, */
/*   { client: "blender",
    services: [5],
    metadata: {
      descr: "R&D conception produit",
      overview: <>Dans le cadre de notre engagement pour l'innovation produit, nous avons mené une recherche approfondie (R&D) en collaboration avec Loolunoonu afin de concevoir un blender performant et ergonomique, répondant aux besoins des utilisateurs.
      <br /><br />
      De l’étude des matériaux à l’optimisation du design, notre approche a intégré tests utilisateurs, analyses techniques et exploration des dernières tendances en électroménager. L’objectif : proposer une solution alliant efficacité, durabilité et esthétisme, tout en garantissant une expérience intuitive et agréable.
      <br /><br />
      Grâce à cette collaboration, nous avons posé les bases d’un produit qui redéfinit les standards du marché.</>,
      link: "",
      thumbnail: "_cover.jpg",
      tags: ["product design", "bottle", "blender"],
      css: "object-bottom",
      industry: ["consumer goods"],
      year: 2019,
      profile: prf.sm,
    },
  }, */
  { client: "casamançaise",
    services: [3],
    metadata: {
      descr: "R&D pour nouveau produit",
      overview: `Après avoir rencontré Casamançaise, nous avons créé une série de visuels dans le but de donner une direction artistique à la communication d'un nouveau produit à lancer: les cups de 35CL.`,
      link: "",
      thumbnail: "_cover.JPG",
      industry: ["food & beverages"],
      year: 2020,
      profile: prf.sm,
    },
  },
/*   { client: "desq",
    services: [5],
    metadata: {
      descr: "R&D + Design Table",
      overview: `Une table conceptualisée spécialement pour un producteur. Un mobilier de travail spacieux accueillant les besoins créatifs de l'artiste.`,
      link: "",
      thumbnail: "_cover.jpg",
      industry: ["furniture", "product design", "manufacturing"],
      year: 2019,
      profile: prf.sm,
    },
  }, */
  /*  {client: "Diambo",
    services: [1, 3],
    metadata: {
      descr: "Home | Clothing | Cosmetics | Studio ",
      css: "origin-center object-center",
      link: "",
      industry: ["fashion"],
      year: 2021,
      profile: prf.st,
    },
  }, */

  { client: "dina groupe",
    services: [1],
    metadata: {
      descr: "Immobilier & Design d'Intérieur",
      overview:"Notre travail a consisté à produire une identité flexible répondant à la fois aux exigences de production (un logo d’entreprise solide pouvant signer ses réalisations) et aux besoins marketing (un ensemble d’éléments visuels plus courants, généralement utilisés par le groupe), permettant ainsi un branding robuste de leurs produits tout en offrant une présence en ligne plus légère et subtile.",
      thumbnail: "_cover.png",
      link: "",
      industry: ["Real Estate", "Architecture", "Interior Design"],
      year: 2021,
      profile: prf.st,
    },
  }, 
  { client: "finesse fabrics",
    services: [2, 3],
    metadata: {
      descr: "3D rendered launch campaign",
      overview: "Pour le lancement de sa 1ère collection de tissus riches aux couleurs attrayantes, nous avons proposé à Finesse Fabrics une approche innovatrice: faire de son textile une production 3D avec style.",
      thumbnail: "_cover.jpg",
      css:"origin-bottom object-bottom",
      link: "",
      industry: ["fashion"],
      year: 2022,
      profile: prf.st,
    },
  },
  { client: "fold",
    services: [1, 2, 5],
    metadata: {
      descr: "Station de recharge multi-appareils",
      overview: "",
      thumbnail: "_cover.gif",
      css:"origin-bottom object-bottom",
      link: "",
      industry: ["fashion"],
      year: 2022,
      profile: prf.st,
    },
  },
/*   { client: "guerlain",
    services: [3],
    metadata: {
      descr: "Culture of Beauty",
      overview: "Dans le cadre de notre collaboration avec Guerlain, nous avons conçu une série de rendus 3D et d’animations en motion design mettant en valeur l’élégance et l’innovation de la marque. Ce projet vise à sublimer l’univers visuel de Guerlain à travers des compositions sophistiquées, des textures réalistes et des mouvements fluides, en parfaite harmonie avec l’ADN de la maison.",
      thumbnail: "_cover.jpg",
      css: "*:translate-y-[-10%]",
      link: "",
      industry: ["perfume"],
      year: 2024,
      profile: prf.lg,
    },
  }, */
  { client: "ingersoll",
    services: [3],
    metadata: {
      descr: "Timeless.",
      overview: "",
      thumbnail: "_cover.jpg",
      css: "*:translate-y-[-10%]=",
      link: "",
      industry: ["watches"],
      year: 2021,
      profile: prf.lg,
    },
  },
  { client: "ISIF dakar business school",
    services: [1,2,4],
    metadata: {
      descr: "Institut Supérieur de Formation et d'Ingénierie",
      overview: "",
      thumbnail: "_cover.jpg",
      css: "*:translate-y-[-10%]=",
      link: "",
      industry: ["watches"],
      year: 2025,
      profile: prf.lg,
    },
  },
  { client: "jewoh",
    services: [3],
    metadata: {
      descr: "L'innovation capillaire",
      thumbnail: "_cover.jpg",
      heroVideo: "jewoh.mov",
      heroVideoPrev: "jewoh_short.mp4",
      link: "",
      industry: ["beauty", "haircare"],
      year: 2024,
      profile: prf.sm,
    },
  },
  { client: "kaizen business support",
    services: [1],
    metadata: {
      descr: "Services de gestion financière",
      overview: "Nous avons façonné l’identité visuelle de Kaizen, un service de gestion financière, en créant une image de marque cohérente et distinctive. De la conception du logo à l’élaboration d’une charte graphique complète, nous avons donné à Kaizen tous les éléments nécessaires pour affirmer son positionnement et renforcer sa présence sur le marché. Une identité qui reflète ses valeurs : rigueur, fluidité et modernité. ",
      link: "",
      thumbnail: "_cover.png",
      industry: ["consulting", "finances"],
      year: 2021,
      profile: prf.sm,
    },
  },
/*   { client: "kouna bags",
    services: [1, 2,],
    metadata: {
      descr: "Luxury Fashion",
      overview: "",
      link: "",
      thumbnail: "_cover.jpg",
      industry: ["fashion", "bags"],
      year: 2019,
      profile: prf.sm,
    },
  },  */
  { client: "layepro consulting",
    services: [1],
    metadata: {
      descr: "Maison de production",
      overview: "Un rebranding marque le début d’une nouvelle ère. Pour Layepro Consulting, c’est aussi un engagement vers une production médiatique pérenne qui a inspiré des personnes à travers le monde. Après dix ans d’existence, nous avons conçu l’identité visuelle de son nouveau service de consulting.",
      link: "",
      thumbnail: "_cover.jpg",
      industry: ["media production", "consulting"],
      year: 2023,
      profile: prf.sm,
    },
  },
  { client: "les parfums d'Igor",
    services: [3],
    metadata: {
      descr: "Offrez-vous un voyage olfactif",
      overview: <>Dans le cadre d'une étude de cas pour Parfums d'Igor, nous avons réalisé des rendus 3D pour mettre en valeur leurs produits. La photographie de produit en studio peut être très coûteuse et offre peu de flexibilité, ce qui limite souvent la créativité et l’adaptabilité. <br/> <br/>En utilisant la 3D, nous avons surmonté ces contraintes, offrant ainsi une solution plus abordable et flexible pour la présentation des produits. Grâce à cette approche, nous permettons à nos clients de bénéficier d’images de haute qualité tout en ayant plus de liberté dans leur production visuelle.</>,
      link: "",
      thumbnail: "_cover.jpg",
      industry: ["perfumes"],
      year: 2021,
      profile: prf.sm,
    },
  },
/*   { client: "littleThingsDk",
    services: [1],
    metadata: {
      descr: "5 ans de créatrion de contenu culinaire",
      overview:"Pour ses 5 ans, notre créatice de contenue tant appréciée nous a confié le design de son identité visuelle.",
      link: "",
      thumbnail: "_cover.png",
      heroVidCSS: "object-contain h-full bg-black",
      heroVideo:"assets/Video_LTDK_Render01_.mp4",
      industry: ["food & beverages"],
      year: 2022,
      profile: prf.md,
    },
  }, */
  { client: "lucid",
    services: [4],
    locked: true,
    metadata: {
      descr: "Compromise Nothing - Lucid Motors",
      link: "",
      thumbnail: "_cover.jpg",
      industry: ["automotive"],
      year: 2022,
      profile: prf.lg,
    },
  }, 
  { client: "loolu noonu",
    services: [1, 2, 3, 4 ,5],
    starred: true,
    metadata: {
      descr: "",
      overview:"",
      link: "https://www.instagram.com/loolunoonu",
      thumbnail: "_cover.jpg",
      heroVideo: "assets/AW— LLNN, GoingThroughEmotions.mp4",
      herovidCSS: "!object-bottom !origin-bottom",
      industry: ["industrial design", "consumer electronics"],
      year: 2020,
      profile: prf.st,
    },
  },
  { client: "macaron and co",
    services: [1,/*  3, */ 5],
    starred: true,
    metadata: {
      descr: "Macarons artisanaux aux saveurs africaines",
      overview:"Macaron & Co est une marque de pâtisserie artisanale fondée à Dakar en 2022, dédiée à la valorisation des saveurs africaines. \n Dans le cadre de son rebranding pour repositionner le business, nous avons conçu une identité chaleureuse et savoureuse à travers des attributs visuels vibrants et un packaging marquant.",
      link: "",
      thumbnail: "_cover.jpg",
      industry: ["food & beverages"],
      year: 2024,
      profile: prf.sm,
    },
  },
/*   { client: "menorah",
    services: [1],
    metadata: {
      descr: "",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["fashion"],
      year: 2022,
      profile: prf.st,
    },
  }, */

  { client: "mela label",
    services: [1,4],
    metadata: {
      descr: "Le geste avant tout",
      thumbnail: "_cover.jpg",
      // heroVideo: "mela_pre_web.mov",
      // heroVideoPrev: "MELA_Tease.mp4",
      link: "",
      industry: ["fashion", "home"],
      year: 2026,
      profile: prf.st,
    },
  },
 /*  { client: "milliardaire",
    services: [3],
    metadata: {
      descr: "Sans parfum la peau est muette",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["perfumes"],
      year: 2024,
      profile: prf.lg,
    },
  }, */
  { client: "montblanc",
    services: [3],
    locked: true,
    metadata: {
      descr: "Ident No. MB130855",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["eyewear"],
      year: 2024,
      profile: prf.lg,
    },
  },
  { client: "nakala",
    services: [1, 2, 3],
    starred: true,
    metadata: {
      descr: "Onctueusement bon",
      overview:"Soyez déterminés! Comme l’a si bien dit notre vache préférée, nous avons — ensemble — propulsé Nak’Ala au sommet! Dans l’arène impitoyable des produits laitiers, notre nouvel entrant 🐮 a soufflé un vent de fraîcheur, arrachant l’herbe sous les sabots des dinosaures 🦕 grâce à une gamme audacieuse et une ‘Blue-Ocean Strategy’ de contenu.",
      link: "https://www.instagram.com/p/Cg5GHT_l0VM/",
      thumbnail: "_cover.jpg",
      heroVideo: "nakala.mov",
      // heroVideoPrev: "assets/tease/nakala_countdown_lawwd.MOV",
      heroVideoPrev: "assets/loops/R_test_Menthe.mp4",
      herovidCSS: "object-center",
      credits: [
        { title: "3D Generalist", by: "Daouda Diallo"}, 
        { title: "Co-creative Direction", by: "Oumou Touré (O'), Daouda Diallo"},
        { title: "Production", by: "us"}
      ],
      reviews: [
        {from: "@ficcelllo", text:"Enfiiiin 😍😍😍"},
        {from: "@ndate_thm", text:"J’adoreeee 😍"},
        {from: "@mvsseine", text:"Wahouuuu 👏! On voit tout le travaille effectué sur ce projet qui devient réalité. Plein de réussite @mmd_amar 🙏🏻😘"},
        {from: "@matifaaaaa_", text:"Waouh c'est trop bien fait 🥰😻💘"},
        {from: "@kuromaluu", text:"YAAAAAAASSSS 🔥"},
      ],
      industry: ["food & beverages", "foodtech"],
      year: 2022,
      profile: prf.st,
    },
  },
/*   { client: "noema venera",
    services: [1, 2, 3,4],
    metadata: {
      descr: "Le Luxe A Fleur De Peau",
      overview:".",
      link: "https://www.instagram.com/noemavenera/",
      thumbnail: "_cover.jpg",
      industry: ["food & beverages", "foodtech"],
      year: 2025,
      profile: prf.st,
    },
  }, */
  { client: "omana",
    services: [2, 3],
    metadata: {
      descr: "Simple sophistication du luxe artisanal",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["bags"],
      year: 2022,
      profile: prf.sp,
    },
  },
  { client: "oumou group",
    services: [1, 4],
    metadata: {
      descr: "Nouveaux Horizons.",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["bags"],
      year: 2022,
      profile: prf.sp,
    },
  },
  { client: "portraitsOfX",
    services: [1,2,3,4],
    metadata: {
      descr: "Curated connections of a lifetime",
      overview: "",
      link: "",
      thumbnail: "_cover.jpg",
      css: "origin-center object-center",
      industry: ["well-being"],
      year: 2019,
      profile: prf.sm,
    },
  },
  { client: "sanù",
    services: [2,3],
    metadata: {
      descr: "a sensorial experience — launch 3D content",
      css: "origin-center object-center",
      link: "",
      thumbnail: "_cover.jpg",
      industry: ["well-being"],
      year: 2022,
      profile: prf.sm,
    },
  },
  { client: "serene senses",
    services: [3],
    metadata: {
      descr: "Bougies et huiles",
      overview: "Partner-campaign, Serene Senses was provided with beautiful 3D rendered content — on Us.",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["well-being", "candles", "oils"],
      year: 2022,
      profile: prf.st,
    },
  },
  { client: "sisters of afrika",
    services: [1],
    metadata: {
      descr: "Brand identity",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["fashion"],
      year: 2022,
      profile: prf.st,
    },
  },
  { client: "soBomb dollz",
    services: [3],
    metadata: {
      descr: "For the pretty ones",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["cosmetics"],
      year: 2022,
      country: ["usa", "senegal"],
      profile: prf.sm,
    },
  },
  { client: "so'Fatoo",
    services: [3,5],
    metadata: {
      descr: "a new era for a modest-fashion giant",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["fashion"],
      year: 2022,
      country: ["senegal"],
      profile: prf.st,
    },
  },
  { client: "SYCS",
    services: [1,2],
    metadata: {
      descr: "Senegalese Youth Career Summit",
      overview: "L'éducation d'une personne est le cadeau à une génération entière. Le SYCS, ambitieux projet porté par 3 jeunes sénégalaises primées des meilleures écoles, a été l'opportunité pour nous de créer un projet identitaire.",
      thumbnail: "_cover.JPG",
      link: "",
      industry: ["education"],
      year: 2019,
      country: ["senegal"],
      profile: prf.st,
    },
  },
  { client: "sondelles",
    services: [3],
    locked: true,
    metadata: {
      descr: "3D campaign for candles brand",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["well-being"],
      country: ["senegal"],
      year: 2022,
      profile: prf.st,
    },
  },
/*   { client: "spaceX",
    services: [3, 4],
    metadata: {
      descr: "Rockets that connect the world.",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["space engineering"],
      year: 2024,
      country: ["united states of america"],
      profile: prf.lg,
    },
  }, */
  { client: "teewTickets",
    services: [1, 2, 3, 4],
    metadata: {
      descr: "Online ticketing plateform",
      overview: "En un temps record, nous avons conçu une identité visuelle sophistiquée, accompagnée d’un système flexible et dynamique de création et de gestion de tickets, aussi bien physiques que numériques, pour les événements dont TeewTickets s'occupe de la billetterie.",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["tech"],
      year: 2021,
      country: ["senegal"],
      profile: prf.st,
    },
  },
  { client: "tennis",
    services: [2, 3],
    metadata: {
      descr: "Jeu. Set. & Match",
      overview: "",
      thumbnail: "_cover.png",
      link: "",
      industry: ["sports"],
      year: 2021,
      country: ["senegal"],
      profile: prf.st,
    },
  },
  { client: "vessel",
    services: [1, 2, 4],
    initiative: true,
    venture: true,
    locked: true,
    metadata: {
      descr: "Vous connecter aux personnes qui comptent.",
      overview: "VESSEL est une application conçue pour renforcer les liens familiaux en offrant un espace dédié aux connexions intimes. Avec VESSEL, les utilisateurs peuvent construire et explorer leur arbre généalogique tout en interagissant avec les membres de leur famille qu’ils ont ajoutés. L’application transforme la généalogie en une expérience vivante et dynamique, permettant de partager des souvenirs, d’échanger en privé et de célébrer l’histoire familiale ensemble.",
      thumbnail: "_cover.jpg",
      link: "",
      industry: ["tech"],
      year: 2023,
      ongoing: true,
      country: ["senegal"],
      profile: prf.st,
    },
  },
  { client: "welly food",
    services: [2, 3],
    metadata: {
      descr: "Poudre de fruits séchés",
      overview: "It's soo gooOOOod! Nous avons travaillé avec Welly Food sur leur branding, améliorant la représentation et visibilité de leur catalogue de produits.",
      link: "",
      thumbnail: "_cover.JPEG",
      industry: ["food & beverages"],
      tags: ["packaging", "3Drenders", "fruits"],
      year: 2019,
      country: ["france", "senegal"],
      profile: prf.sm,
    },
  },
  { client: "xewlu",
    services: [1, 2, 3, 5],
    metadata: {
      descr: "Le vrai goût des céréales",
      link: "",
      thumbnail: "_cover.jpg",
      industry: ["food & beverages"],
      year: 2022,
      profile: prf.sm,
    },
  },
  { client: "yafa beauty",
    services: [3],
    metadata: {
      descr: "Love Edition Campaign 3D Visuals",
      overview: "photos et animations 3D.",
      thumbnail: "assets/YAFA_R019.jpeg",
      // thumbnail:"_cover.jpeg",
      heroVideo: "assets/yafa_loveedition_lawwd.mov",
      link: "",
      industry: ["perfumes"],
      year: 2022,
      profile: prf.lg,
    },
  },
    { client: "yellow",
    services: [1,2,3,4],
    starred: true,
    metadata: {
      descr: "Expression d'héritage africain",
      overview: "Stratégie & Design d'identité visuelle + image de marque et Direction artistique produits + média.",
      thumbnail: "_cover.jpg",
      // thumbnail:"_cover.jpeg",
      // heroVideo: "assets/ylw-coulisses-1.mp4",
      link: "",
      industry: ["perfumes"],
      year: 2026,
      profile: prf.md,
    },
  },
  { client: "zara",
    services: [3],
    metadata: {
      descr: "Tobacco Collection Campaign 3D Visuals",
      overview: "Pour la sortie de la collection Tobacco, au sein d'une équipe créative, nous avons modélisé, texturé et rendu des étiquettes expérimentales, des designs de bouteilles, des photos et animations 3D.",
      thumbnail: "_cover.png",
      heroVideo: "ZaraPerfume_r02.mp4",
      heroVideoPrev: "assets/loops/Zara_Loop02_LAWWD®_.mp4",
      heroVidCSS: "object-bottom",
      link: "",
      industry: ["perfumes"],
      year: 2020,
      profile: prf.lg,
    },
  },
]

export const indices = projects.map(pr => ({
  client: pr.client,
  services: pr.services.map(serviceId => services[serviceId - 1]?.short || "Unknown Service").filter(service => service !== "Unknown Service")
}));



export const backup = [
 {  client: "workWithDaouda",
      services: [1, 2, 4],
      metadata: {
        descr: "",
        link: "",
        industry: ["consulting"], year: 2024, profile: prf.sm
      }
    }, 
  {  client: "maraz",
      services: [1],
      metadata: {
        descr: "",
        link: "",
        industry: ["fashion"], year: 2021, profile: prf.md
      }
    },
   {  client: "loolu noonu",
      services: [1, 3, 4],
      metadata: {
        descr: "",
        link: "",
        industry: ["fashion"], year: 2021, profile: prf.md
      }
    }, 

 {  client: "revolut",
    services: [3, 4],
    metadata: {
      descr: "Change the way you money",
      thumbnail: "_cover.webp",
      herovideo: "rev_cards.mp4",
      link: "",
      industry: ["finances"], year: 2024, profile: prf.md
    }
  }, 

 {  client: "l'oeil du lion",
      services: [1],
      metadata: {
        descr: "",
        link: "",
        industry: ["production"], year: 2024, profile: prf.st
      }
  }, 
  {  client: "amsatou sow sidibe",
      services: [1, 2],
      metadata: {
      descr: "",
      link: "",
      industry: ["political figure"], year: 2023, profile: prf.md }
    }, 
  { client: "razer blade",
    services: [3],
    metadata: {
      descr: "",
      link: "",
      industry: ["tech"], year: 2023, profile: prf.md
    }
  },
  { client: "sisters of africa",
    services: [1],
    metadata: {
      descr: "",
      link: "",
      industry: ["fashion"], year: 2022, profile: prf.sm
    }
  },
  { client: "arka concept store",
    services: [1],
    metadata: {
      descr: "",
      link: "",
      industry: ["fashion", 'concept store'], year: 2022, profile: prf.sm
    }
  },
  { client: "black terminus AR",
    services: [4],
    metadata: {
      descr: "",
      link: "",
      industry: ["augmented reality"], year: 2022, profile: prf.sm
    }
  },
  { client: "dina groupe",
    services: [1],
    metadata: {
      descr: "",
      link: "",
      industry: ["architecture", "interior"], year: 2022, profile: prf.sm
    }
  },
  { client: "oumou group",
    services: [1, 4],
    metadata: {
      descr: "",
      link: "",
      industry: ["tech", "commerce"], year: 2021, profile: prf.lg
    }
  },

  { client: "nike",
    services: [3],
    metadata: {
      descr: "",
      link: "",
      industry: ["fashion"], year: 2022, profile: prf.sm
    }
  },

  { client: "whatsapp",
    services: [3,],
    metadata: {
      descr: "",
      link: "",
      industry: ["tech"], year: 2022, profile: prf.sm
    }
  },
  { client: "fenty beauty",
    services: [3,],
    metadata: {
      descr: "",
      link: "",
      industry: ["beauty"], year: 2022, profile: prf.sm
    }
  },
  { client: "sassoumane",
    services: [3],
    metadata: {
      descr: "",
      link: "",
      industry: ["beauty"], year: 2022, profile: prf.sm
    }
  },

  { client: "museum of Egypt",
    services: [1],
    metadata: {
      descr: "",
      link: "",
      industry: ["public"], year: 2022, profile: prf.lg
    }
  }, 
]
